(function ($) {
  "use strict";

  var HugeSingleImageScrollHandler = elementorModules.frontend.handlers.Base.extend({
    onInit: function () {
      this.initReveal();
    },

    initReveal: function () {
      var section = this.$element.find(".thha-sis-section")[0];
      if (!section || typeof IntersectionObserver === "undefined") {
        return;
      }

      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate-in");
              obs.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.2,
        }
      );

      observer.observe(section);
    },
  });

  window.addEventListener("elementor/frontend/init", function () {
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/thha-huge-single-image-scroll.default",
      function ($scope) {
        new HugeSingleImageScrollHandler({
          $element: $scope,
        });
      }
    );
  });
})(jQuery);
